import { render, staticRenderFns } from "./course-ware.vue?vue&type=template&id=0def6a62"
import script from "./course-ware.vue?vue&type=script&lang=js"
export * from "./course-ware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0def6a62')) {
      api.createRecord('0def6a62', component.options)
    } else {
      api.reload('0def6a62', component.options)
    }
    module.hot.accept("./course-ware.vue?vue&type=template&id=0def6a62", function () {
      api.rerender('0def6a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/course-ware.vue"
export default component.exports